import React from 'react';
import StandardButton from './StandardButton';
import type { ButtonProps } from '@mui/material';

type ActionButtonProps = Omit<ButtonProps, 'variant'> & {
  children: React.ReactNode;
};

const ActionButton: React.FC<ActionButtonProps> = ({ children, ...props }) => {
  return (
    <StandardButton variant="primary" {...props}>
      {children}
    </StandardButton>
  );
};

export default ActionButton;
